var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollect = function SvgCollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.708 4.293a1 1 0 0 1 0 1.414L9.416 7H15a1 1 0 1 1 0 2H9.415l1.294 1.293a1 1 0 1 1-1.416 1.414l-3-3a.996.996 0 0 1-.291-.65v-.009a1.008 1.008 0 0 1 .29-.755h.001l3-3c.39-.39 1.024-.39 1.415 0ZM4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })));
};
export default SvgCollect;